module.exports = __webpack_public_path__ + "img/logo-paloma-large@2x.7a96dda1.png";